import { render, staticRenderFns } from "./GroupTotalWidget.vue?vue&type=template&id=57344c47"
import script from "./GroupTotalWidget.vue?vue&type=script&lang=js"
export * from "./GroupTotalWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports